const trustPoints = [
  {
    icon: 'ri-government-line',
    title: 'Based on Government of India Healthcare Guidelines',
    description: 'All pregnancy and vaccination information follows NHM (National Health Mission) and Ministry of Health guidelines trusted, verified, and up-to-date.',
    color: 'teal'
  },
  {
    icon: 'ri-database-2-line',
    title: 'Designed Using Real Healthcare Data',
    description: 'Hospital information, cost data, and service availability are sourced from real institutional data not guesswork or generic recommendations.',
    color: 'sky'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Focused on Maternal & Child Safety',
    description: 'Every feature is designed with one priority: the safety and wellbeing of mothers and their babies throughout the care journey.',
    color: 'rose'
  }
];

const stats = [
  { value: '21+', label: 'Hospitals Analyzed', icon: 'ri-hospital-line', color: 'teal' },
  { value: '40', label: 'Pregnancy Weeks Covered', icon: 'ri-calendar-line', color: 'sky' },
  { value: '100%', label: 'Free to Access', icon: 'ri-price-tag-3-line', color: 'rose' },
  { value: 'NHM', label: 'Guideline Compliant', icon: 'ri-government-line', color: 'green' }
];

const statColors: Record<string, string> = {
  teal: 'text-teal-600 bg-teal-50',
  sky: 'text-sky-600 bg-sky-50',
  rose: 'text-rose-500 bg-rose-50',
  green: 'text-emerald-600 bg-emerald-50'
};

const iconBgColors: Record<string, string> = {
  teal: 'bg-teal-50 text-teal-600',
  sky: 'bg-sky-50 text-sky-600',
  rose: 'bg-rose-50 text-rose-500'
};

export default function Trust() {
  return (
    <section id="trust" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-100 rounded-full mb-5">
            <i className="ri-verified-badge-line text-teal-600"></i>
            <span className="text-sm font-semibold text-teal-700">Why Trust Us</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
            Built for{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-sky-500">
              Real Families
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We built MomsFirstCare with care, rigor, and a deep understanding of what Indian families go through during pregnancy and early parenthood.
          </p>
        </div>

        {/* Trust points */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {trustPoints.map((point, index) => (
            <div key={index} className="border border-gray-100 rounded-2xl p-7 hover:border-teal-100 hover:-translate-y-1 transition-all">
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mb-5 ${iconBgColors[point.color]}`}>
                <i className={`${point.icon} text-3xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug">{point.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-gradient-to-r from-slate-50 to-teal-50 border border-teal-100 rounded-2xl p-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mx-auto mb-3 ${statColors[stat.color]}`}>
                  <i className={`${stat.icon} text-2xl`}></i>
                </div>
                <div className={`text-3xl font-extrabold mb-1 ${statColors[stat.color].split(' ')[0]}`}>
                  {stat.value}
                </div>
                <div className="text-sm text-gray-500 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
